import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@getnuvo/importer-react'

export const popoverInfo: ThemeAPI['popoverInfo'] = {
  backgroundColor: theme.colors.grey800,
  borderColor: theme.colors.grey800,
}
